<template>
  <div>
    <p class="empty" role="status">{{ $t('intake.portal.refundUnavailable') }}</p>
    <div class="actions">
      <router-link class="btn btn-secondary" :to="supportLink">{{ $t('intake.portal.supportNewCta') }}</router-link>
      <router-link class="btn btn-primary" :to="{name: 'portalPayments', params: {lang: $route.params.lang || 'fa'}}">{{ $t('intake.portal.refundBack') }}</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PortalRefundStep',
  computed: {
    supportLink() {
      const raw = String(this.$route.query.id || '')
      const query = {topic: 'PAYMENT', from: 'refund'}
      if (/^\d{1,20}$/.test(raw)) query.factor_id = raw
      return {name: 'portalRequestNew', params: {lang: this.$route.params.lang || 'fa'}, query}
    },
  },
}
</script>
